import React from "react";
import { motion } from "framer-motion";
import { Shield, Award, MapPin, Clock } from "lucide-react";
import { ABOUT } from "@/constants/testIds";
import { SITE } from "@/lib/site";

const BADGES = [
  { Icon: Shield, label: "DGAC Certifié", caption: "Scénarios S1-S3" },
  { Icon: Award, label: "Studio primé", caption: "Awards Live 2024" },
  { Icon: MapPin, label: "France, Europe & Maroc", caption: "Mobilité totale" },
  { Icon: Clock, label: "Devis 24h", caption: "Réactivité garantie" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid={ABOUT.root}
      className="relative py-28 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 grid gap-16 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 rounded-full glass px-4 py-2 text-xs uppercase tracking-[0.2em] text-white/70">
            À propos · drones3x.fr
          </div>
          <h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
            Le entreprise française du <span className="italic font-semibold">spectacle aérien</span>.
          </h2>
          <p className="mt-6 text-white/65 leading-relaxed">
            Fondé en France, <strong className="text-white">drones3x.fr</strong> est un
            collectif de pilotes brevetés, scénaristes et ingénieurs lumière. Nous orchestrons
            des essaims jusqu'à 800 drones lumineux, en pleine conformité DGAC, pour signer
            des moments d'exception&nbsp;: mariages, événements corporate, festivals, sport.
          </p>
          <p className="mt-4 text-white/65 leading-relaxed">
            Nous intervenons partout en France — Paris, Lyon, Marseille, Bordeaux, Toulouse,
            Nice, Strasbourg, Cannes — ainsi qu'en Europe et au Maroc sur demande.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-5">
            {BADGES.map((b, i) => (
              <motion.div
                key={b.label}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="rounded-2xl glass-strong p-6"
              >
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#007AFF]/15 text-[#007AFF]">
                  <b.Icon size={18} />
                </div>
                <div className="font-display text-lg font-semibold mt-4">{b.label}</div>
                <div className="text-sm text-white/55 mt-1">{b.caption}</div>
              </motion.div>
            ))}
          </div>

          {/* City marquee */}
          <div className="mt-10 rounded-2xl glass-strong p-6 overflow-hidden">
            <div className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
              Spectacles dans toute la France
            </div>
            <div className="relative overflow-hidden">
              <div className="marquee-track flex whitespace-nowrap gap-10 text-2xl md:text-3xl font-display font-light text-white/70">
                {[...SITE.cities, ...SITE.cities].map((c, i) => (
                  <span key={c + i} className="inline-flex items-center gap-10">
                    <span>{c}</span>
                    <span className="text-[#007AFF]">·</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
